import React, { useState, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import LoginForm from './LoginForm'
import SetNewPasswordForm from './SetNewPasswordForm'
import { useNavigate, useParams } from 'react-router-dom'
import Button from '../formfields/Button'
import GuestUserLoginForm from './GuestUserLoginForm'
import SingleSignOn from './SingleSignOn'
import ExternalUserLoginForm from './ExternalUserLoginForm'

type Props = {
    loginOptions: null | ObjectStringKeyAnyValue
    authChallenge: ObjectStringKeyAnyValue | null
    setAuthChallenge: React.Dispatch<React.SetStateAction<any>>
}


function ChooseLoginType({
    loginOptions,
    authChallenge,
    setAuthChallenge,
}: Props) {

   const {
       t
   } = useContext(GlobalContext)

    const navigate = useNavigate()
    const { checklistId, assetId } = useParams()
    const [showForm, setShowForm] = useState<string | null>()

    const guestLoginPermitted = loginOptions && (
        loginOptions['Guest'] ||
        loginOptions['guest'] ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('guest')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Guest'))
    ) ? true : false

    const cognitoLoginPermitted = loginOptions && (
        loginOptions['cognito'] ||
        loginOptions['Cognito'] ||
        loginOptions['email'] ||
        loginOptions['Email'] ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('email')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Email')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('cognito')) ||
        (loginOptions['Checklists'] && loginOptions['Checklists'].includes('Cognito'))
    ) ? true : false


    const externalIndividualLogin = loginOptions && loginOptions['externalIndividual'] ? true : false

    // console.log('loginOptions', loginOptions)
    // console.log('guestLoginPermitted', guestLoginPermitted)
    // console.log('cognitoLoginPermitted', cognitoLoginPermitted)

    if (externalIndividualLogin && checklistId) {
        return <div className={`w-full flex flex-col gap-2`}>
            <h3 className={`font-righteous text-2xl text-brand-dark mb-4`}>
                {t('Auth.ChooseLoginType.welcome')}
            </h3>
            <ExternalUserLoginForm />
        </div>
    }

    return <div className={`w-full flex flex-col gap-2`}>

        <h3 className={`font-righteous text-2xl text-brand-dark mb-4`}>
            {t('Auth.ChooseLoginType.welcome')}
        </h3>

        {showForm === 'email' ? <LoginForm
            authChallenge={authChallenge}
            setAuthChallenge={setAuthChallenge}
            setShowForm={setShowForm}
        /> : ''}

        {showForm === 'guest' ? loginOptions && <GuestUserLoginForm
            pin={loginOptions['Guest']['pin']}
            allowRememberMe={loginOptions['Guest']['allowRememberMe']}
            setShowForm={setShowForm}
        /> : ''}

        {!showForm && <div className={`w-full flex flex-col gap-2`}>

            {(!checklistId || cognitoLoginPermitted) && <Button
                onClick={() => setShowForm(`email`)}
                text={t('Auth.ChooseLoginType.logInWithEmail')}
                variant={'secondary'}
                size={'big'}
                id={`loginWithEmail`}
                sameWindow={true}
            />}

            {loginOptions && guestLoginPermitted && <Button
                onClick={() => setShowForm(`guest`)}
                text={
                    loginOptions['Guest']['pin'] ?
                    t('Auth.ChooseLoginType.logInWithPin') :
                    t('Auth.ChooseLoginType.guestLogIn')
                }
                variant={'secondary'}
                size={'big'}
                id={`loginAsGuest`}
                sameWindow={true}
            />}

        </div>}

        {showForm !== 'guest' && (loginOptions || !showForm) && <SingleSignOn />}

    </div>
}
export default ChooseLoginType